import React from 'react';

function DashboardExportTab() {
  return (
    <div style={{ margin: '200px', textAlign: 'center', fontSize: '24px' }}>
      Coming soon...
    </div>
  );
}

export default DashboardExportTab;
